if (!customElements.get("modal-dialog")) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this)
      );
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });
      if (this.classList.contains("media-modal")) {
        this.addEventListener("pointerup", (event) => {
          if (
            event.pointerType === "mouse" &&
            !event.target.closest("deferred-media, product-model")
          )
            this.hide();
        });
      } else {
        this.addEventListener("click", (event) => {
          if (event.target.nodeName === "MODAL-DIALOG") this.hide();
        });
      }
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.documentElement.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }
    hide() {
      document.documentElement.classList.remove("overflow-hidden");
      this.removeAttribute("open");
      if (this.openedBy) removeTrapFocus(this.openedBy);
    }
  }
  customElements.define("modal-dialog", ModalDialog);

  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector(".modal-opener");
      if (!button) return;
      button.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define("modal-opener", ModalOpener);

  const trapFocusHandlers = {};

  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;

      document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }

  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
  }
}

if (!customElements.get("class-toggler")) {
  class ClassToggler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.elementToToggle = this.querySelector(
        this.getAttribute("data-element-to-toggle")
      );
      this.classToToggle = this.getAttribute("data-class-to-toggle");
      if (!this.elementToToggle || !this.classToToggle) {
        console.error(
          "data-element-to-toggle data-class-to-toggle not found or invalid."
        );
        return;
      }
      this.addEventListener("click", this.toggleChildClass.bind(this));
      this.elementToToggle.addEventListener(
        "click",
        this.removeToggleClass.bind(this)
      );
      document.body.addEventListener(
        "click",
        this.handleOutsideClick.bind(this)
      );
    }

    toggleChildClass() {
      this.elementToToggle.classList.toggle(this.classToToggle);
    }

    removeToggleClass(event) {
      event.stopPropagation();
      this.elementToToggle.classList.remove(this.classToToggle);
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target)) {
        this.elementToToggle.classList.remove(this.classToToggle);
      }
    }
  }
  customElements.define("class-toggler", ClassToggler);
}
